export default __webpack_public_path__ + "static/media/@bylaary.38b52f62.jpg";